import { EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES } from 'cpool-constants';
import { schemaEuropaceProcessEvents, schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const EuropaceProcessEventsTableDefinitionZod = z.object({
    events: schemaEuropaceProcessEvents,
    lastRequestedAt: z.coerce.date().nullable(),
    loanRequestId: schemaId,
    requestStatus: z.nativeEnum(EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES),
});

export type EuropaceProcessEventsTableSchema = z.infer<typeof EuropaceProcessEventsTableDefinitionZod>;
